import React from 'react';
import MoreLogs from './LoadMore';
import LatestLogs from './Latest';
import LogMappedList from './LogMappedList';
import useHistorical from '../../../modules/historical/useHistorical';

type Props2 = {
  mapLog?: any;
}
export const HistoricalBox: React.FC<Props2> = (props) => {
  const {
    getLatestLogs,
    latestStatus,
    getMoreLogs,
    moreStatus,
    hasAllLogs,
  } = useHistorical();
  
  return (
    <div>
      <LatestLogs status={latestStatus} getLatestLogs={getLatestLogs} />
      {props.children ? props.children : <LogMappedList />}
      <MoreLogs
        status={moreStatus}
        getMoreLogs={getMoreLogs}
        hasAllLogs={hasAllLogs}
      />
    </div>
  );
};

export default HistoricalBox;
